import SqftStore from "../../../store/sqftStore";
import sqftSlabManager from "../../../store/sqftSlabManager";
import sqftShapeIntersectionsManager from "../../../store/sqftShapeIntersectionsManager";
import sqftImageManager from "../../../store/sqftImageManager";
import {
  detectSlabConflicts,
  handleOpenSlabModeConflict
} from "../../../../popup/modalFix/slabFix/slabModeConflictHelper";

export default class ShapeIntersections {
  __shape;
  overlappedWithShapeIds = [];

  constructor(shape) {
    this.__shape = shape;
  }

  setOverlappedWithShapeIds = (ids) => {
    this.overlappedWithShapeIds = ids
  }

  addOverlappedWithShape = (id) => {
    if (!this.overlappedWithShapeIds.includes(id)) {
      this.overlappedWithShapeIds.push(id);
    }
  }

  removeOverlappedWithShape = (id) => {
    if (this.overlappedWithShapeIds.includes(id)) {
      this.overlappedWithShapeIds = this.overlappedWithShapeIds.filter(overlappedId => id !== overlappedId);
    }
  }

  handleSlabPlaceholderIntersections = () => {
    if (SqftStore.isSlabMode()) {
      const slabPlaceHolderShapes = sqftSlabManager.getSlabPlaceHolderShapes();
      if (slabPlaceHolderShapes.length) {

        // if (this.__shape.partId === SHAPE_PART_ID.slabPlaceHolder) {
        //   this.onSlabPlaceHolderMove();
        // } else {
        //   this.onCountertopShapeMove(slabPlaceHolderShapes);
        // }

        //sqftShapeIntersectionsManager.updateShapesIntersections();

        const slabConflicts = detectSlabConflicts();
        handleOpenSlabModeConflict(slabConflicts).then(r => void r);

        // if (shouldShowSlabConflict) {
        //
        // } else {
        //   sqftShapeIntersectionsManager.updateSlabPlaceholderFeatureId();
        //
        //   const errorCallback = () => {
        //     this.__shape.shapeMemory.restoreShapePosition();
        //     this.__shape.resetMouseDown();
        //     sqftShapeIntersectionsManager.updateShapesIntersections();
        //   }
        //
        //   sqftShapeIntersectionsManager.showSlabPlaceHolderErrorMessage(slabPlaceHolderShapes, errorCallback);
        // }
      }
    }
  }

  handleSlabImageIntersections = () => {
    if (SqftStore.isSlabMode()) {
      const slabImages = sqftImageManager.getSlabImages();
      if (slabImages.length) {
        //sqftShapeIntersectionsManager.updateShapesIntersections(); // this is already called in handleSlabPlaceholderIntersections
        //sqftShapeIntersectionsManager.updateShapesFeaturePlacedOnSlabImages();
        sqftShapeIntersectionsManager.updateSlabImagesFeature();

        // const errorCallback = () => {
        //   this.__shape.shapeMemory.restoreShapePosition();
        //   this.__shape.resetMouseDown();
        //   sqftShapeIntersectionsManager.updateShapesIntersections();
        // }
        //
        // sqftShapeIntersectionsManager.showSlabPlaceHolderErrorMessage(slabImages, errorCallback);
      }
    }
  }

  // onSlabPlaceHolderMove = () => {
  //   const counterTopShapes = sqftShapeManager.getCounterTopShapes();
  //   let overlapsWithIds = [];
  //   this.setOverlappedWithShapeIds([]);
  //
  //   for (const counterTopShape of counterTopShapes) {
  //     const shapeIntersections = ShapeHelper.getTwoShapesIntersections(this.__shape, counterTopShape);
  //     const shapeIds = Object.keys(shapeIntersections);
  //     if (shapeIds.length) {
  //       this.__shape.setFeatureId(clone(counterTopShape.featureId))
  //       overlapsWithIds.push(shapeIds[0]);
  //     }
  //     //console.log("shapeIntersections", shapeIntersections);
  //   }
  //   this.setOverlappedWithShapeIds(overlapsWithIds);
  // }
  //
  // onCountertopShapeMove = (slabPlaceHolderShapes) => {
  //   for (const slabPlaceHolderShape of slabPlaceHolderShapes) {
  //     slabPlaceHolderShape.shapeIntersections.removeOverlappedWithShape(this.__shape.id);
  //     const shapeIntersections = ShapeHelper.getTwoShapesIntersections(slabPlaceHolderShape, this.__shape);
  //     //console.log("shapeIntersections", shapeIntersections);
  //     const shapeIds = Object.keys(shapeIntersections);
  //     if (shapeIds.length) {
  //       slabPlaceHolderShape.setFeatureId(clone(this.__shape.featureId));
  //       slabPlaceHolderShape.shapeIntersections.addOverlappedWithShape(+shapeIds[0]);
  //     }
  //   }
  // }


}
